"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var UIUtils_1 = require("../../../../../../../../shared/modules/UIUtils");
var react_ace_1 = require("react-ace");
var CardRowButtonTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowButtonTextEditor");
var AffilateEmailTemplateTestJSONEditor = /** @class */ (function (_super) {
    __extends(AffilateEmailTemplateTestJSONEditor, _super);
    function AffilateEmailTemplateTestJSONEditor(props) {
        return _super.call(this, props) || this;
    }
    AffilateEmailTemplateTestJSONEditor.prototype.componentWillMount = function () {
        this.setState({
            jsonTestRaw: UIUtils_1.UIUtils.Base64DecodeU(this.props.testJSONBase64),
            eMailToSend: this.props.record.for_test_email,
            is_window_maximized: false
        });
        this.props.state.setExtBreadCrumbPath([
            "Шаблоны email",
            "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0442\u0435\u0441\u0442\u043E\u0432\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445: [" + this.props.record.title + "]"
        ]);
    };
    AffilateEmailTemplateTestJSONEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.SetGwsEmailTestJSONContent(this.props.record.key, UIUtils_1.UIUtils.Base64EncodeU(this.state.jsonTestRaw), this.state.eMailToSend, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Конфигурация успешно изменена!");
            });
        }
        else {
            notificationHelper_1.default.ShowTextTopRightErrorNotify("Контент не может быть пуcтым!");
        }
    };
    AffilateEmailTemplateTestJSONEditor.prototype.OnLoadDataClick = function () {
        var _this = this;
        this.props.data.GetRawTestJSONData(this.props.record.key, function (dataBase64) {
            _this.setState({
                jsonTestRaw: UIUtils_1.UIUtils.Base64DecodeU(dataBase64),
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Конфигурация успешно загружена!");
            });
        });
    };
    AffilateEmailTemplateTestJSONEditor.prototype.isDataValid = function () {
        if (!this.state.jsonTestRaw) {
            return false;
        }
        if (this.state.jsonTestRaw.length === 0) {
            return false;
        }
        return true;
    };
    AffilateEmailTemplateTestJSONEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AffilateEmailTemplateTestJSONEditor.prototype.OnMaxButtonClick = function (isMax) {
        this.setState({ is_window_maximized: isMax });
    };
    AffilateEmailTemplateTestJSONEditor.prototype.getFormTitle = function () {
        return "Изменить тестовые данные";
    };
    AffilateEmailTemplateTestJSONEditor.prototype.onChangeJSON = function (newValue) {
        this.setState({ jsonTestRaw: newValue });
    };
    AffilateEmailTemplateTestJSONEditor.prototype.onTryToSendEMailClick = function () {
        if (this.state.eMailToSend) {
            if (this.state.eMailToSend.length >= 5) {
                this.props.data.CheckGwsEmailTemplate(this.props.record.key, function () {
                    notificationHelper_1.default.ShowTextTopRightInfoNotify("Запрос на отправку EMail выполнен!");
                });
            }
            else {
                notificationHelper_1.default.ShowTextTopRightErrorNotify("Поле EMail некорректно");
            }
        }
        else {
            notificationHelper_1.default.ShowTextTopRightErrorNotify("Поле EMail не заполнено");
        }
    };
    AffilateEmailTemplateTestJSONEditor.prototype.getEditorHeight = function () {
        if (this.state.is_window_maximized) {
            return "calc( 100vh - 330px )";
        }
        else {
            return "410px";
        }
    };
    AffilateEmailTemplateTestJSONEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), onMaxButtonClick: this.OnMaxButtonClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600, showMaxButton: true },
            React.createElement("div", { style: {
                    minHeight: "500px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start"
                } },
                React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Email:", placeholder: "Email для тестовой отправки", buttonHint: "Отправить Email" }, readonly: false, onButtonClick: this.onTryToSendEMailClick.bind(this), onValueChanged: function (newVal) {
                        _this.setState({
                            eMailToSend: newVal
                        });
                    }, value: this.state.eMailToSend, buttonIcon: "mail" }),
                React.createElement(react_ace_1.default, { mode: "json", theme: "sqlserver", onChange: this.onChangeJSON.bind(this), name: "UNIQUE_ID_OF_RECORD_CONTENT_DIV_JSON", editorProps: { $blockScrolling: true }, width: "100%", height: this.getEditorHeight(), fontSize: 14, value: this.state.jsonTestRaw, style: { borderStyle: "solid", borderWidth: "1px", borderColor: "#d9d9d9" } }),
                React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться", btnLoad: "Загрузить" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this), onLoadClick: this.OnLoadDataClick.bind(this) }))));
    };
    return AffilateEmailTemplateTestJSONEditor;
}(React.Component));
exports.default = AffilateEmailTemplateTestJSONEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/config/email/AffilateEmailTemplateTestJSONEditor.tsx
// module id = 2036
// module chunks = 0